package fr.frux.shared.domain.model

/** Un compte masqué par l'utilisateur courant (#515, ADR 0029). [blockedAt] en epoch millis. */
data class BlockedUser(
    val userId: Long,
    val username: String,
    val blockedAt: Long,
)

/**
 * Comptes système des imports en masse (V10, V55, V82, V83, V84, V85, ADR 0010) reconnus par leur pseudo réservé,
 * le contrat public n'exposant pas `external_source`. Ni masquables ni signalables (ADR 0029) :
 * l'entrée n'est pas proposée. [IMPORT_USERNAMES] est la liste de `ImportedTreeSource` de la fiche
 * arbre, [SITE_IMPORT_USERNAMES] celle de `ImportedSiteSource` de la fiche lieu, chacune
 * verrouillée par un test de sa fiche.
 */
object SystemAccounts {
    val IMPORT_USERNAMES: Set<String> =
        setOf(
            "openstreetmap",
            "rennes-metropole",
            "montpellier-metropole",
            "bordeaux-metropole",
            "metropole-de-lyon",
            "eurometropole-de-strasbourg",
            "nantes-metropole",
            "toulouse-metropole",
            "plaine-commune",
            "ville-de-paris",
            "grenoble-alpes-metropole",
            "eurometropole-de-metz",
            "departement-de-la-lozere",
        )

    /** Sources de lieux : jardins OSM (ADR 0037), vergers d'Angers (#690), Cergy et La Rochelle (#713). */
    val SITE_IMPORT_USERNAMES: Set<String> =
        setOf(
            "openstreetmap",
            "ville-d-angers",
            "ville-de-cergy",
            "agglomeration-de-la-rochelle",
        )

    fun isImport(username: String?): Boolean =
        username != null && (username in IMPORT_USERNAMES || username in SITE_IMPORT_USERNAMES)
}
